import { useEffect } from 'react';

import { useBoostStore } from '@/store/useBoostStore';

export const useBoostCountdown = () => {
  const {
    remainingSeconds,
    isBoostActive,
    initCountdown,
    tick,
    getTotalSeconds
  } = useBoostStore();

  const isActive = isBoostActive();
  const totalSeconds = getTotalSeconds();

  useEffect(() => {
    if (!isActive) return;

    initCountdown();

    const intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [isActive, initCountdown, tick]);

  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  const formatted = [hours, minutes, seconds]
    .map((v) => String(v).padStart(2, '0'))
    .join(':');

  const progress = totalSeconds > 0 ? remainingSeconds / totalSeconds : 0;

  return { hours, minutes, seconds, formatted, isActive, progress };
};